import { useEffect, useState } from "react";
import { browser_utils } from "../utils/frfr-browser-utils";
import { _zzyourmap_ajax } from "../utils/zz/zz-yourmap-ajax-adapter";
import { _zzyourmap_convert_layer_title_to_layer_key } from "../utils/zz/zz-yourmap-layer-utils";
// import { _zzyourmap_lib_legend_keys } from "../utils/zz/zz-yourmap-data-keys-and-values-lib";
import { yourmapNavMaker, _zzyourmap_routing_browser_title_update } from "../utils/zz/zz-yourmap-routing";
import { _zzyourmap_extract_marker_entities_by_route_subdestination_id } from "../utils/zz/zz-yourmap-utils";
import UniBtn from "./UniBtn";
import YourmapLeafletContainerUniversal from "./YourmapLeafletContainerUniversal";
import YourmapMapPageWrapper from "./YourmapMapPageWrapper";


//
const _refresh_markers_visibility_by_scrpt = (filtersLegend, map_legend_keys_used_regular) => {
  if (window.yourmapscript && typeof window.yourmapscript.refresh_markers_visibility === 'function') {
    window.yourmapscript.refresh_markers_visibility(filtersLegend, map_legend_keys_used_regular);
  } else {
    console.log('ERROR window.yourmapscript.refresh_markers_visibility function NOT FOUND');
  }
};


//
const LEGEND_HEADER_ITEM_KEY = '_ALL_LAYERS';
const LEGEND_HEADER_ITEM_TITLE = 'sve'; // first checkbox item in Legend widget
//
const _make_map_legend_keys_and_lookup = (marker_layer_titles_used) => {
  let map_legend_keys_used_plus_header = [LEGEND_HEADER_ITEM_KEY];
  let map_legend_keys_used_regular = [];
  let map_legend_lookup_obj_key_to_title = {};
  map_legend_lookup_obj_key_to_title[LEGEND_HEADER_ITEM_KEY] = LEGEND_HEADER_ITEM_TITLE;
  //
  if (Array.isArray(marker_layer_titles_used)) {
    marker_layer_titles_used.forEach(layer_title => {
      const layer_key = _zzyourmap_convert_layer_title_to_layer_key(layer_title);
      map_legend_keys_used_plus_header.push(layer_key);
      map_legend_keys_used_regular.push(layer_key);
      map_legend_lookup_obj_key_to_title[layer_key] = layer_title;
    });
  }
  const map_legend_keys_used_regular_length = map_legend_keys_used_regular.length;
  //
  return {
    map_legend_keys_used_plus_header,
    map_legend_keys_used_regular,
    map_legend_lookup_obj_key_to_title,
    map_legend_keys_used_regular_length, // for useEffect
  };
};

//
const YourmapMapLegend = (props) => {
  const {
    // _zzyourmap_legend_keys,
    map_legend_keys_used_regular,
    map_legend_lookup_obj_key_to_title,
    filtersLegend,
    setFiltersLegend,
  } = props;
  const [opened, setOpened] = useState(true);
  //
  return (
    <>
      <div className={"yourmap__map__legend" + (opened ? "" : " yourmap__map__legend--closed")}>
        <div className="yourmap__card yourmap__card--map-legend uu-shadow-alien-fluent2-tile-shadow">
          <div className="yourmap__map__legend__title" onClick={() => { setOpened(!opened) }}><span>Legenda</span><div className="unicompo-rotating-triangle__aura-container">
            <div className="unicompo-rotating-triangle__aura-clickable">
              <i className="fa fa-caret-right" aria-hidden="true"></i>
            </div>
          </div></div>
          <div className="yourmap__filters">
            <div key={LEGEND_HEADER_ITEM_KEY} className={"yourmap__filters__item" + (false ? " yourmap__map__subdestinations-selector__option--active" : "")}>
              <label className="uniformcompo__label-wrapping-checkbox" htmlFor={'select_filter_'}>
                <span className="label">{'sve'}</span>
                <span className="uu-anyinput__control-container uniformcompo__checkbox-aura">
                  <input
                    type="checkbox"
                    name={'select_filter_'}
                    readOnly={false}
                    disabled={false}
                    checked={filtersLegend[LEGEND_HEADER_ITEM_KEY] === true}
                    onChange={() => {
                      // CASE check/uncheck 'SVE' checkbox in legend header
                      setFiltersLegend(state => {
                        if (state?.[LEGEND_HEADER_ITEM_KEY] === true) {
                          const updated_filtersLegend = {};
                          updated_filtersLegend[LEGEND_HEADER_ITEM_KEY] = false;
                          map_legend_keys_used_regular.forEach((layer_key) => {
                            updated_filtersLegend[layer_key] = false;
                          });
                          return {
                            ...state,
                            ...updated_filtersLegend,
                            [LEGEND_HEADER_ITEM_KEY]: false,
                          };
                        } else {
                          const updated_filtersLegend = {};
                          updated_filtersLegend[LEGEND_HEADER_ITEM_KEY] = true;
                          map_legend_keys_used_regular.forEach((layer_key) => {
                            updated_filtersLegend[layer_key] = true;
                          });
                          return {
                            ...state,
                            ...updated_filtersLegend,
                            [LEGEND_HEADER_ITEM_KEY]: true,
                          };
                        }
                      });
                    }}
                  />
                </span>
              </label>
            </div>
            {
              (Array.isArray(map_legend_keys_used_regular)) ? (
                <>
                  {
                    map_legend_keys_used_regular.map((layer_key) => {
                      const layer_title = map_legend_lookup_obj_key_to_title[layer_key];
                      return (
                        <div key={layer_key} className={"yourmap__filters__item" + (false ? " yourmap__map__subdestinations-selector__option--active" : "")}>
                          <label className="uniformcompo__label-wrapping-checkbox" htmlFor={'select_filter_'}>
                            <span className="label">{layer_title}</span>
                            <span className="uu-anyinput__control-container uniformcompo__checkbox-aura">
                              <input
                                type="checkbox"
                                name={'select_filter_'}
                                readOnly={false}
                                disabled={false}
                                checked={filtersLegend[layer_key] === true}
                                onChange={() => {
                                  // CASE check/uncheck regular layer
                                  setFiltersLegend(state => {
                                    if (state?.[layer_key] === true) {
                                      return {
                                        ...state,
                                        [layer_key]: false,
                                        [LEGEND_HEADER_ITEM_KEY]: false,
                                      };
                                    } else {
                                      return {
                                        ...state,
                                        [layer_key]: true,
                                      };
                                    }
                                  });
                                }}
                              />
                            </span>
                          </label>
                        </div>
                      );
                    })
                  }
                </>
              ) : (null)
            }
          </div>
        </div>
      </div>
    </>
  );
};


//
const YourmapSectionMapV1 = (props) => {
  const {
    destination_entities_fetching,
    current_destination_entity,
    map_props_1,
    route_destination_id,
    route_subdestination_id,
    setRouteRoot,
    viarouterNavigate,
    handleClickGoBack,
    _goBack_href,
    setRouteSubdestination,
    // markerable_entities,
    ymthing_entities,
    ymostalo_v1_entities,
    setUniModalPortableContent_3,
    setUniModalPortableClose_3,
  } = props.appPack;
  // console.log('geouri za canada bariff je: geo:51.2,-159.6?z=2');

  const title = 'Mapa ' + current_destination_entity?.destinacija_naslov;
  _zzyourmap_routing_browser_title_update(title);

  const [mapFetching, setMapFetching] = useState(null);
  let _mapFetching = false;
  if (mapFetching !== false) {
    _mapFetching = true;
  }

  useEffect(() => {
    if (destination_entities_fetching === false) {
      if (mapFetching === null) {
        setMapFetching(true);
        setTimeout(() => {
          setMapFetching(false);
        }, 300);
        // }, 600);
      } else {
        setMapFetching(true);
        setTimeout(() => {
          setMapFetching(false);
        }, 400);
        // }, 800);
      }
    }
  }, [route_subdestination_id, destination_entities_fetching]);

  //
  const { map_props_markers_arr, marker_layer_titles_used } = _zzyourmap_extract_marker_entities_by_route_subdestination_id(ymthing_entities, ymostalo_v1_entities, route_destination_id, route_subdestination_id);
  //
  const {
    map_legend_keys_used_plus_header,
    map_legend_keys_used_regular,
    map_legend_lookup_obj_key_to_title,
    map_legend_keys_used_regular_length, // for useEffect
  } = _make_map_legend_keys_and_lookup(marker_layer_titles_used);

  //
  const [filtersLegend, setFiltersLegend] = useState({
    [LEGEND_HEADER_ITEM_KEY]: true,
  });
  useEffect(() => {
    if (map_legend_keys_used_regular_length > 0) {
      setFiltersLegend(state => {
        const updated_state = {};
        updated_state[LEGEND_HEADER_ITEM_KEY] = true;
        map_legend_keys_used_regular.forEach((layer_key) => {
          updated_state[layer_key] = true;
        });
        return updated_state;
      });
      _refresh_markers_visibility_by_scrpt(); // without argument means all vsible
    }
  }, [map_legend_keys_used_regular_length]);
  useEffect(() => {
    // automatic refresh marker visibility by script when filtersLegend state change
    _refresh_markers_visibility_by_scrpt(filtersLegend, map_legend_keys_used_regular); //
  }, [filtersLegend]);
  /*
  useEffect(() => { // OLD
    if (Array.isArray(_zzyourmap_lib_legend_keys)) {
      setFiltersLegend(state => {
        const updated_state = {};
        updated_state[LEGEND_HEADER_ITEM_KEY] = true;
        _zzyourmap_lib_legend_keys.forEach((legend_item) => {
          updated_state[legend_item] = true;
        });
        return updated_state;
      });
    }
  }, []);
  */

  // kreira css class string
  const _make_extraClassFilterLegend = () => {
    let extraClassFilterLegend = ' yourmap__map-layer-filtering__hide';
    Object.keys(filtersLegend).forEach((layer_key) => {
      if (filtersLegend[layer_key] === false && layer_key !== LEGEND_HEADER_ITEM_KEY) {
        extraClassFilterLegend += (' yourmap__map-layer-filtering__hide-layer--' + layer_key);
      }
    }
    );
    return extraClassFilterLegend;
  };
  //


  //
  let jsxMarkerPopupContent = null;
  const [clickedMarkerSingle, setClickedMarkerSingle] = useState({});
  const _make_jsxMarkerPopupContent = (marker_single) => {
    console.log('_make_jsxMarkerPopupContent');
    console.log('marker_single', marker_single);
    if (marker_single.key > 0) { // validate quick
      const key = marker_single.key;
      const item = marker_single.entity;
      const nav_path = (() => {
        const thing_id = item.of_id;
        if (item.vr_tablename === 'ym_table_smestaj') {
          return yourmapNavMaker.ROOT_SMESTAJ_ITEM(route_destination_id, thing_id);
        } else if (item.vr_tablename === 'ym_table_restoran') {
          return yourmapNavMaker.ROOT_RESTORAN_ITEM(route_destination_id, thing_id);
        } else if (item.vr_tablename === 'ym_table_servis') {
          return yourmapNavMaker.ROOT_SERVIS_ITEM(route_destination_id, thing_id);
        } else if (item.vr_tablename === 'ym_table_prodavnica') {
          return yourmapNavMaker.ROOT_PRODAVNICA_ITEM(route_destination_id, thing_id);
        } else if (item.vr_tablename === 'ym_table_aktivnost') {
          return yourmapNavMaker.ROOT_AKTIVNOST_ITEM(route_destination_id, thing_id);
        } else if (item.vr_tablename === 'ym_table_znamenitost') {
          return yourmapNavMaker.ROOT_ZNAMENITOST_ITEM(route_destination_id, thing_id);
        } else if (item.vr_tablename === 'ym_table_ostalo_v2') {
          return yourmapNavMaker.ROOT_OSTALO_ITEM(route_destination_id, thing_id);
        } else if (item.vr_tablename === 'ym_table_ostalo_v1') {
          // return yourmapNavMaker.ROOT_OSTALO_ITEM(route_destination_id, thing_id);
          if (item.smestaj_tab === 'blog') {
            return yourmapNavMaker.ROOT_BLOG_ITEM(route_destination_id, thing_id);
          }
        }
      })();
      // const marker_popup_main_img_src = _zzyourmap_extract_smestaj_main_img_url(item);
      const marker_popup_main_img_src = item._main_img_url;
      const style = {
        // backgroundImage: 'url("' + img_url_full + '")',
        backgroundImage: 'url("' + marker_popup_main_img_src + '")',
      };
      jsxMarkerPopupContent = (
        <>
          <div className="yourmap__map__marker_popup-content" data-marker-key={key}>
            <h2 className="yourmap__map__marker_popup-content__title">{item.smestaj_naslov}</h2>
            <div className="yourmap__map__marker_popup-content__img-bg" style={style}></div>
            <p className="info-description"><b>{item.smestaj_podnaslov}</b></p>
            <p className="info-description-long uu-text-justify">{item.smestaj_opis}</p>
            <div className="uu-gap-standalone-4px"></div>
            <div className="yourmap__map__marker_popup-content__footer">
              {
                item.smestaj_tab !== 'NONE' && (
                  <UniBtn
                    wide
                    fullWidth
                    titleBeforeIcon
                    title="Više"
                    i_NOT="fa fa-map-o"
                    extraClass="yourmap__theme__custom-btn-blue"
                    handleClick={(e) => {
                      e.preventDefault();
                      const thing_id = item.of_id;
                      if (item.vr_tablename === 'ym_table_smestaj') {
                        viarouterNavigate(yourmapNavMaker.ROOT_SMESTAJ_ITEM(route_destination_id, thing_id));
                        setUniModalPortableClose_3();
                      } else if (item.vr_tablename === 'ym_table_restoran') {
                        viarouterNavigate(yourmapNavMaker.ROOT_RESTORAN_ITEM(route_destination_id, thing_id));
                        setUniModalPortableClose_3();
                      } else if (item.vr_tablename === 'ym_table_servis') {
                        viarouterNavigate(yourmapNavMaker.ROOT_SERVIS_ITEM(route_destination_id, thing_id));
                        setUniModalPortableClose_3();
                      } else if (item.vr_tablename === 'ym_table_prodavnica') {
                        viarouterNavigate(yourmapNavMaker.ROOT_PRODAVNICA_ITEM(route_destination_id, thing_id));
                        setUniModalPortableClose_3();
                      } else if (item.vr_tablename === 'ym_table_aktivnost') {
                        viarouterNavigate(yourmapNavMaker.ROOT_AKTIVNOST_ITEM(route_destination_id, thing_id));
                        setUniModalPortableClose_3();
                      } else if (item.vr_tablename === 'ym_table_znamenitost') {
                        // return yourmapNavMaker.ROOT_ZNAMENITOST_ITEM(route_destination_id, thing_id);
                        viarouterNavigate(yourmapNavMaker.ROOT_ZNAMENITOST_ITEM(route_destination_id, thing_id));
                        setUniModalPortableClose_3();
                      } else if (item.vr_tablename === 'ym_table_ostalo_v2') {
                        // return yourmapNavMaker.ROOT_OSTALO_ITEM(route_destination_id, thing_id);
                        viarouterNavigate(yourmapNavMaker.ROOT_OSTALO_ITEM(route_destination_id, thing_id));
                        setUniModalPortableClose_3();
                      } else if (item.vr_tablename === 'ym_table_ostalo_v1') {
                        /*
                        if (item.smestaj_tab === 'SERVISI') {
                          // setRouteRoot('ROOT_SERVIS_ITEM', thing_id);
                          viarouterNavigate(yourmapNavMaker.ROOT_SERVIS_ITEM(route_destination_id, thing_id));
                        } else
                        */
                        /*
                        if (item.smestaj_tab === 'OSTALO') {
                          // setRouteRoot('ROOT_OSTALO_ITEM', thing_id);
                          viarouterNavigate(yourmapNavMaker.ROOT_OSTALO_ITEM(route_destination_id, thing_id));
                        }
                        */
                        // if (item.smestaj_tab === 'BLOG') {
                        if (item.smestaj_tab === 'blog') {
                          // return yourmapNavMaker.ROOT_BLOG_ITEM(route_destination_id, thing_id);
                          viarouterNavigate(yourmapNavMaker.ROOT_BLOG_ITEM(route_destination_id, thing_id));
                        }
                        setUniModalPortableClose_3();
                      }
                    }}
                    href={nav_path}
                  />
                )
              }
            </div>
          </div>
        </>
      );
      return jsxMarkerPopupContent;
    }
    return null;
  };
  jsxMarkerPopupContent = _make_jsxMarkerPopupContent(clickedMarkerSingle);
  if (jsxMarkerPopupContent) {
  } else { // FIX
    jsxMarkerPopupContent = (<>Klikni na marker da vidiš detalje.</>);
  }

  //
  const _cbClickLatLng = null;
  const _cbClickMarker = (key, marker_single, is_small_window) => {
    console.log('_cbClickMarker', key, marker_single);
    if (marker_single.key > 0) { // validate quick
      const key = marker_single.key;
      const item = marker_single.entity;
      if (marker_single.marker_is_link) { // CASE marker with link
        //
        if (typeof marker_single.marker_link_href === 'string') { // validate link url
          // OPEN URL IN BROWSER
          browser_utils.browser_go_url(marker_single.marker_link_href);
        }
        //
      } else { // CASE regular marker with popup
        jsxMarkerPopupContent = _make_jsxMarkerPopupContent(marker_single);
        setClickedMarkerSingle(marker_single); // to add popup in sidebar
        if (is_small_window === true) { // CASE open modal on small screen
          setUniModalPortableContent_3({
            options: {
              zIndex: 7399,
            },
            jsx: (
              <>
                {jsxMarkerPopupContent}
              </>
            ),
          });
        } else { // CASE big screen
          // do nothing
          // popup will be added in sidebar
        }
      }
    }
  };
  const _cbGoBack = (enableClickLatLng) => {
    // Android the Up button
    // setRouteRoot('ROOT_DESTINATION_ITEM');
    // TODO
    // setRouteRoot('ROOT_HOME');
    // handleClickGoBack(e);
  };
  let options = {
    ...map_props_1,
    enableClickLatLng: false, // DISABLE pick lat lng coordinates
    _cbClickLatLng,
    _cbClickMarker,
    _cbGoBack,
    markers_arr: map_props_markers_arr,
  };

  let jsxMapHeader = (
    <>
      {
        Array.isArray(current_destination_entity?._subdestinations) ? (
          <div className="yourmap__map__subdestinations-selector">
            {
              current_destination_entity._subdestinations.map((item) => {
                return (
                  <div key={item._option_value_for_map} className={"yourmap__map__subdestinations-selector__option" + (item._option_value_for_map === route_subdestination_id ? " yourmap__map__subdestinations-selector__option--active" : "")} onClick={() => { setRouteSubdestination(item._option_value_for_map) }}>{item._option_title}</div>
                );
              })
            }
          </div>
        ) : (null)
      }
    </>
  );

  return (
    <>
      <section className="yourmap__section yourmap__section--map">
        <div className="inner222 yourmap__map-standalone-layout">
          <div className="yourmap__map-standalone-layout__header-placeholder"></div>
          <div className={"yourmap__map" + _make_extraClassFilterLegend()}>
            <YourmapMapPageWrapper
              _cbGoBack={_cbGoBack}
              handleClickGoBack={handleClickGoBack}
              _goBack_href={_goBack_href}
              jsxSidebar={jsxMarkerPopupContent}
              jsxMapHeader={jsxMapHeader}
              mapFetching={_mapFetching}
              jsxMapLegend={(<YourmapMapLegend
                map_legend_keys_used_regular={map_legend_keys_used_regular}
                map_legend_lookup_obj_key_to_title={map_legend_lookup_obj_key_to_title}
                filtersLegend={filtersLegend}
                setFiltersLegend={setFiltersLegend}
              />)}
            >
              <YourmapLeafletContainerUniversal
                ll={[51.2, -159.6]}
                options={options}
                _cbGoBack_NOT={_cbGoBack}
                jsxSidebar={jsxMarkerPopupContent}
                jsxMapHeader={jsxMapHeader}
                mapFetching={_mapFetching}
              />
            </YourmapMapPageWrapper>
            {/*
            <MapContainer center={[51.505, -0.09]} zoom={13} scrollWheelZoom={false}>
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              <Marker position={[51.505, -0.09]}>
                <Popup>
                  A pretty CSS3 popup. <br /> Easily customizable.
                </Popup>
              </Marker>
            </MapContainer>
            */}
          </div>

        </div>
      </section>
    </>
  );
};


// DEFAULT COMPONENT
const YourmapMapStandalonePage = (props) => {
  const {

  } = props.appPack;
  //
  useEffect(() => {
    // componentDidMount
    // TODO
    document.body.classList.add('modal-opened');
    // componentWillUnmount
    return () => {
      document.body.classList.remove('modal-opened');
    };
  }, []);
  //
  return (
    <>
      <YourmapSectionMapV1 appPack={props.appPack} />
    </>
  );
};

export default YourmapMapStandalonePage;